export default function () {
    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('js-share')) {
            const url = e.target.getAttribute('href');

            if (url && url.indexOf('http') === 0) {
                const newWindow = window.open(url, '', 'height=450, width=700');

                if (window.focus) {
                    newWindow.focus();
                }

                e.preventDefault();
            }
        }
    });
}
